import { AdapterConfigure } from './AdapterConfigure';
import { RepositoryImplMain } from './RepositoryImplMain';
import { RootState } from '../../../shared/Infraestructure/AdapterStore';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { addLoading, hideIconMenu, removeLoading } from '../../../shared/Infraestructure/SliceGenerico';
import { AdapterStorage } from '../../../shared/Infraestructure/AdapterStorage';
import { useState } from 'react';
import { AdapterGenerico } from '../../../shared/Infraestructure/AdapterGenerico';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AdapterValidator } from '../../../shared/Infraestructure/AdapterValidator';
import { UseCaseChangePassword } from '../Application/UseCaseChangePassword';
import { DtoReqChangePassword } from '../Domain/DtoReqChangePassword';
import { LanguageTranslate } from '../../../shared/Infraestructure/LanguageTranslate';
import { AdapterNotification, TypeModeNotification } from '../../../shared/Infraestructure/AdapterNotification';
import { IFormNotification, initIFormNotification } from '../Domain/Form/IFormNotification';

export const Controller = () => {
    const { auth, user } = useSelector((state: RootState) => state.auth);
    const { websocket, dbLocal } = useSelector((state: RootState) => state.generico);
    const dispatch: Dispatch = useDispatch();

    const repository: RepositoryImplMain = new RepositoryImplMain(websocket, dbLocal, dispatch, AdapterConfigure.SCHEMA, AdapterConfigure.ENTITY);
    const languageTranslate = LanguageTranslate();

    const [showLanguage, setShowLanguage] = useState<boolean>(false);
    const [showChangePassword, setShowChangePassword] = useState<boolean>(false);

    const { language } = AdapterStorage.get('language');
    const adapterNotification = new AdapterNotification();

    const formChangePassword = useFormik({
        initialValues: {
            newPassword: '',
            reNewPassword: '',
        } as any,
        validationSchema: Yup.object({
            newPassword: Yup.string().required('Ingresar Nueva Contraseña'),
            reNewPassword: Yup.string().required('Ingresar Repetir Nueva Contraseña').oneOf([Yup.ref('newPassword'), null], 'La contraseña deben coincidir')
        }),

        onSubmit: (values, formikHelpers) => { },
    });


    const init = async () => {
        try {
            dispatch(hideIconMenu());
            // dispatch(addLoading('Cargando datos...'));
            await loadData();
            // dispatch(removeLoading())
        } catch (error) {
            dispatch(removeLoading())
            AdapterGenerico.createMessage(languageTranslate.textoAlerta, (error as Error).message, 'warning');
        }
    };

    const loadData = async () => {
        const activeNotification = await adapterNotification.hasActiveSubscription();
        const metodoNotification = await adapterNotification.getStateNotification();
        const dictionary: Record<TypeModeNotification, number[]> = {
            "ALL": [1, 2],
            "INDIVIDUAL": [1],
            "GROUP": [2]
        };

        formNotification.setValues({
            active: !!activeNotification,
            metodoNotification: (activeNotification && metodoNotification) ? dictionary[metodoNotification] : []
        })
    };

    const onChangeLanguage = async (code: string) => {
        AdapterStorage.set('language', code);
        window.location.reload();
    };

    const onChangePassword = async (name: string, value: any) => {
        formChangePassword.setFieldValue(name, value);
    };

    const onSubmitChangePassword = async (e: Event) => {
        try {
            e.preventDefault();
            e.stopPropagation();

            try { await formChangePassword.submitForm(); } catch (error) { }
            try { AdapterValidator.validate(await formChangePassword.validateForm()); } catch (error) { AdapterGenerico.createMessage(languageTranslate.textoIncompleto, (error as Error).message, 'warning', false); return null; }

            const param: DtoReqChangePassword = {
                IdUser: user.IdUser,
                Password1: formChangePassword.values.newPassword,
                Email: user.Email,
                Identificacion: user.Identificacion,
                TypeLogin: user.TypeLogin,
                idSocket: null,
                allData: null,
                Users: {
                    General: {
                        IdUser: user.IdUser,
                        User: user.User,
                        LastName: `${user.LastNameFather} ${user.LastNameMother}`,
                        Name: user.Name,
                        Perfil: user.Profile.filter(row => row.Principal.toLocaleLowerCase() === 'si')[0]?.Perfil ?? '',
                    }
                }
            }

            await (new UseCaseChangePassword(repository)).exec(param);
            formChangePassword.resetForm();
            AdapterGenerico.createMessage(languageTranslate.textoExitoso, languageTranslate.textoExitosoCambioPassword, 'success');
        } catch (error) {
            console.error(error);

            dispatch(removeLoading());
            AdapterGenerico.createMessage(languageTranslate.textoAlerta, (error as Error).message, 'warning', false);
        }
    }

    /** Form Notificaciones */
    const formNotification = useFormik<IFormNotification>({
        initialValues: initIFormNotification,
        onSubmit: () => {},
        validationSchema: Yup.object({
            active: Yup.boolean(),
            metodoNotification: Yup.array().when(['active'], {
                is: (value: boolean) => !!value,
                then: (schema) => schema.min(1, languageTranslate.moduloNotificacion.validate.metodoNotificacion)
            })
        })
    })

    const onChangeFormNotification = (name: keyof IFormNotification, value: any) => {
        const dictionary: Record<keyof IFormNotification, Function> = {
            active: () => {
                formNotification.setValues({ active: value, metodoNotification: value ? [1]: [] })
            },
            metodoNotification: () => {
                const newOptions = formNotification.values.metodoNotification;
                const indexOption = newOptions.findIndex(row => row === value);
                indexOption === -1 ? newOptions.push(value) : newOptions.splice(indexOption, 1);
                formNotification.setFieldValue(name, newOptions);
            }
        };

        dictionary[name]();
    }

    const onSubmitFormNotification = async () => {
        try {
            dispatch(addLoading({ }));

            await formNotification.submitForm();
            AdapterValidator.validate(await formNotification.validateForm());

            if (formNotification.values.active) {
                const dictionaryOptions: Record<number, TypeModeNotification> = {
                    1: 'INDIVIDUAL',
                    2: 'GROUP',
                }
                const modeNotification: TypeModeNotification = formNotification.values.metodoNotification.length > 1 ? 'ALL' : dictionaryOptions[formNotification.values.metodoNotification[0]];
    
                const hasNotification = await new AdapterNotification().hasActiveSubscription();
                hasNotification ? 
                    await new AdapterNotification().changeModeNotification(user, modeNotification)
                    :
                    await new AdapterNotification().subscribe(user, modeNotification);
            } else {
                await new AdapterNotification().unsubscribe(user);
            }

            AdapterGenerico.createMessage(languageTranslate.textoExitoso, languageTranslate.moduloNotificacion.formSuccess, 'success')
        } catch (error) {
            AdapterGenerico.createMessage(languageTranslate.textoAlerta, (error as Error).message, 'warning');
        } finally {
            dispatch(removeLoading());
        }
    }

    return {
        init,
        auth,
        user,

        showLanguage,
        setShowLanguage,
        language,
        onChangeLanguage,

        showChangePassword,
        setShowChangePassword,
        formChangePassword,
        onChangePassword,
        onSubmitChangePassword,

        formNotification,
        onChangeFormNotification,
        onSubmitFormNotification,
    };
}